import { render, staticRenderFns } from "./Bahn1Statements.vue?vue&type=template&id=479ab805&scoped=true&"
import script from "./Bahn1Statements.vue?vue&type=script&lang=js&"
export * from "./Bahn1Statements.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1Statements.vue?vue&type=style&index=0&id=479ab805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ab805",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
